import styled from 'styled-components';
import { colors, fontFamily } from '../../Utils/tokens';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.overlay};
  font-family: ${fontFamily};
`;

export const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 450px;
  max-width: calc(100vw - 32px);
  padding: 24px 14px 16px;
  overflow: hidden;
  border-radius: 10px;
  background-color: ${colors.surface};
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
`;

export const Title = styled.h2`
  margin: 0;
  padding: 6px 10px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  color: ${colors.onSurface};
`;

export const Divider = styled.div`
  padding: 0 10px;

  &::after {
    content: '';
    display: block;
    height: 1px;
    background-color: ${colors.surfaceOutline};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 10px;
`;

export const Message = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
  color: ${colors.onSurface};
  word-break: break-word;

  strong {
    font-weight: 600;
  }
`;

export const Warning = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  line-height: normal;
  color: ${colors.danger};

  img {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-top: 6px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  padding: 0 10px;
`;

const BaseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: filter 0.15s ease;

  &:hover:not(:disabled) {
    filter: brightness(0.95);
  }

  &:disabled {
    cursor: default;
  }
`;

export const CancelButton = styled(BaseButton)`
  background-color: ${colors.secondary};
  color: ${colors.onSecondary};

  &:disabled {
    box-shadow: inset 0 0 0 1px ${colors.surfaceOutline};
    background-color: ${colors.surface};
    color: ${colors.onSurfacePlaceholder};
  }
`;

export const DangerButton = styled(BaseButton)`
  background-color: ${colors.danger};
  color: ${colors.onPrimary};
`;
